var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 100,
    viewBox: "0 0 140 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1143 56.8231L73.7535 46.939L95.1933 56.4582L94.2985 57.3365L97.1743 58.684C97.3951 58.7875 97.4902 59.0503 97.3868 59.2711C97.2833 59.4919 97.0204 59.587 96.7997 59.4836L93.6262 57.9966L81.9402 69.4691C81.2965 70.103 80.3126 70.2206 79.5372 69.7598L60.1755 58.2056C59.6668 57.9025 59.6331 57.1695 60.1143 56.8231Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4172 76.3017L89.481 55.5833L109.478 64.4158L88.4012 88L68.4172 76.3017Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3352 39.6506L57.1591 45.4172L44.1167 54.6658L33.6738 48.2179L46.3352 39.6506Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2125 68.1409L88.6218 44.7596L111.795 54.7273L87.3706 81.3427L64.2125 68.1409Z",
    fill: "url(#paint0_linear_722_15494)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1894 57.1683L84.71 56.0595L87.3511 53.3144L89.8305 54.4194L87.1894 57.1683Z",
    fill: "url(#paint1_linear_722_15494)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9628 58.8546L88.4833 57.7458L92.2756 53.7996L94.7551 54.9083L90.9628 58.8546Z",
    fill: "url(#paint2_linear_722_15494)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7357 60.5409L92.2562 59.4321L97.8696 53.5916L100.349 54.6965L94.7357 60.5409Z",
    fill: "url(#paint3_linear_722_15494)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5048 62.2273L96.0254 61.1185L99.8177 57.1722L102.297 58.281L98.5048 62.2273Z",
    fill: "url(#paint4_linear_722_15494)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5047 67.8753L78.6617 60.0366C78.3461 59.8787 78.2806 59.5515 78.5193 59.3089C78.758 59.0664 79.2123 58.9933 79.528 59.1511L95.3709 66.9898C95.6867 67.1476 95.7522 67.4749 95.5134 67.7175C95.2747 67.9639 94.8204 68.0331 94.5047 67.8753Z",
    fill: "#D8D8D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4872 69.9351L76.6443 62.0963C76.3286 61.9385 76.2632 61.6113 76.5018 61.3687C76.7405 61.1261 77.1949 61.053 77.5105 61.2108L93.3535 69.0495C93.6691 69.2074 93.7346 69.5347 93.4959 69.7772C93.2572 70.0197 92.8029 70.0928 92.4872 69.9351Z",
    fill: "#D8D8D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4735 71.9909L74.6305 64.1522C74.3148 63.9944 74.2493 63.6671 74.4881 63.4246C74.7268 63.182 75.181 63.1089 75.4968 63.2667L91.3398 71.1054C91.6554 71.2632 91.7209 71.5905 91.4822 71.8331C91.2435 72.0795 90.7892 72.1488 90.4735 71.9909Z",
    fill: "#D8D8D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4563 74.0508L72.6134 66.2121C72.2977 66.0542 72.2323 65.727 72.471 65.4845C72.7096 65.2418 73.164 65.1687 73.4796 65.3266L89.3226 73.1652C89.6384 73.3231 89.7037 73.6504 89.465 73.8929C89.2263 74.1355 88.7721 74.2087 88.4563 74.0508Z",
    fill: "#D8D8D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5013 31.504L59.6079 39.1617L42.6099 51.4433L29 42.8808L45.5013 31.504Z",
    fill: "url(#paint5_linear_722_15494)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3685 44.8482L38.3208 39.8893C38.1399 39.7892 38.1245 39.6237 38.29 39.5159C38.4517 39.408 38.7328 39.4042 38.9138 39.5043L47.9614 44.4631C48.1423 44.5632 48.1577 44.7288 47.9922 44.8366C47.8305 44.9444 47.5494 44.9483 47.3685 44.8482Z",
    fill: "#D8D8D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9904 45.7452L36.9428 40.7864C36.7619 40.6863 36.7464 40.5207 36.912 40.4129C37.0737 40.3051 37.3547 40.3012 37.5357 40.4013L46.5833 45.3602C46.7643 45.4603 46.7796 45.6259 46.6141 45.7336C46.4524 45.8377 46.1713 45.8453 45.9904 45.7452Z",
    fill: "#D8D8D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6119 46.6423L35.5644 41.6835C35.3834 41.5834 35.368 41.4178 35.5336 41.31C35.6953 41.2023 35.9763 41.1983 36.1572 41.2984L45.2049 46.2573C45.3859 46.3574 45.4012 46.523 45.2357 46.6308C45.074 46.7348 44.7929 46.7386 44.6119 46.6423Z",
    fill: "#D8D8D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2336 47.5355L34.1859 42.5767C34.005 42.4766 33.9896 42.311 34.1551 42.2032C34.3169 42.0954 34.598 42.0916 34.7789 42.1917L43.8265 47.1505C44.0074 47.2506 44.0229 47.4162 43.8573 47.524C43.6956 47.6317 43.4145 47.6356 43.2336 47.5355Z",
    fill: "#D8D8D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.856 40.1588L44.8084 35.1999C44.6275 35.0998 44.612 34.9343 44.7776 34.8265C44.9393 34.7187 45.2203 34.7149 45.4013 34.815L54.4489 39.7738C54.6299 39.8739 54.6452 40.0394 54.4798 40.1473C54.318 40.2512 54.0369 40.2589 53.856 40.1588Z",
    fill: "#D8D8D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4775 41.0559L43.43 36.097C43.249 35.9969 43.2336 35.8314 43.3992 35.7236C43.5609 35.6158 43.8419 35.612 44.0228 35.7121L53.0705 40.6708C53.2515 40.771 53.2668 40.9365 53.1013 41.0444C52.9434 41.1483 52.6585 41.156 52.4775 41.0559Z",
    fill: "#D8D8D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1028 41.9491L42.0552 36.9903C41.8742 36.8902 41.8589 36.7246 42.0244 36.6168C42.1861 36.509 42.4672 36.5051 42.6481 36.6052L51.6957 41.5641C51.8766 41.6642 51.8921 41.8297 51.7265 41.9375C51.5648 42.0454 51.2838 42.0492 51.1028 41.9491Z",
    fill: "#D8D8D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7247 42.8461L40.677 37.8873C40.4961 37.7872 40.4807 37.6216 40.6462 37.5138C40.8079 37.406 41.089 37.4021 41.27 37.5022L50.3176 42.4611C50.4985 42.5612 50.514 42.7267 50.3484 42.8345C50.1867 42.9385 49.9056 42.9462 49.7247 42.8461Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8225 8.07636L102.879 15.8303C103.753 16.0998 104.276 16.993 104.088 17.8863L98.0353 46.4728L96.8995 46.8617L71.1042 34.6225L75.6627 9.38923C75.8398 8.39206 76.8523 7.77605 77.8225 8.07636Z",
    fill: "url(#paint6_linear_722_15494)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2224 36.4781L52.6623 47.6125C52.0579 48.0438 52.5276 50.1227 53.1667 50.5L77.4874 64.8838C78.4615 65.4575 79.6974 65.3112 80.5059 64.5219L97.1535 48.3248L96.8955 47.0042L70.2224 36.4781Z",
    fill: "url(#paint7_linear_722_15494)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2224 36.3357L52.6623 47.47C52.0579 47.9012 52.5276 49.9802 53.1667 50.3576L77.4874 64.7413C78.4615 65.315 79.6974 65.1687 80.5059 64.3794L97.1535 48.1822L96.8955 46.8617L70.2224 36.3357Z",
    fill: "url(#paint8_linear_722_15494)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6865 8.46525L101.743 16.2192C102.617 16.4887 103.14 17.3819 102.952 18.2752L96.8993 46.8617L69.9683 35.0113L74.5228 9.78197C74.7 8.78097 75.7163 8.16495 76.6865 8.46525Z",
    fill: "url(#paint9_linear_722_15494)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.873 34.53L75.316 9.92436C75.3929 9.50467 75.7549 9.19669 76.1822 9.19669C76.2708 9.19669 76.3593 9.21214 76.444 9.23517L101.5 16.9892C101.977 17.1355 102.259 17.6168 102.155 18.1057L96.3064 45.7183L70.873 34.53Z",
    fill: "url(#paint10_linear_722_15494)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9646 35.0114L52.8319 47.3161C52.2274 47.7473 52.2698 48.6598 52.9089 49.0371L77.2296 63.4208C78.2037 63.9945 79.4396 63.8482 80.2481 63.0589L96.8957 46.8618L69.9646 35.0114Z",
    fill: "url(#paint11_linear_722_15494)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.248 62.9126C79.4395 63.7019 78.1997 63.8481 77.2295 63.2745L52.9088 48.8907C52.597 48.7059 52.4275 48.3941 52.4083 48.0706C52.3813 48.4402 52.5507 48.8214 52.9088 49.0331L77.2295 63.4169C78.2036 63.9906 79.4395 63.8443 80.248 63.055L96.8956 46.8579L96.7917 46.8116L80.248 62.9126Z",
    fill: "url(#paint12_linear_722_15494)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4369 37.8795L63.2537 42.234C62.8957 42.4188 62.9766 43.0232 63.3885 43.235L84.5714 53.9458C85.0334 54.1845 85.534 54.1614 85.8959 53.8919L92.0213 49.1255C92.4332 48.8176 92.2715 48.0591 91.7402 47.8127L71.2618 37.8988C70.642 37.61 69.9759 37.6024 69.4369 37.8795Z",
    fill: "url(#paint13_linear_722_15494)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7079 42.6498L75.7319 43.1503L76.3249 42.7075L75.3047 42.2032L74.7079 42.6498Z",
    fill: "url(#paint14_linear_722_15494)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.241 41.9336L74.2689 42.4341L74.8657 41.9876L73.8416 41.4871L73.241 41.9336Z",
    fill: "url(#paint15_linear_722_15494)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7781 41.2176L72.8061 41.7181L73.4067 41.2715L72.3825 40.7672L71.7781 41.2176Z",
    fill: "url(#paint16_linear_722_15494)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7921 41.953L71.8086 42.4573L72.4592 41.9722L71.4351 41.4716L70.7921 41.953Z",
    fill: "url(#paint17_linear_722_15494)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.386 41.9376L69.4024 42.4458L70.0146 41.9876L68.9982 41.4832L68.386 41.9376Z",
    fill: "url(#paint18_linear_722_15494)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3407 41.2291L70.3571 41.7335L70.9962 41.2599L69.9721 40.7594L69.3407 41.2291Z",
    fill: "url(#paint19_linear_722_15494)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0969 44.7942L80.1211 45.2947L80.7063 44.8597L79.6822 44.3592L79.0969 44.7942Z",
    fill: "url(#paint20_linear_722_15494)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5598 45.5104L81.5839 46.0109L82.1653 45.5797L81.1411 45.0753L80.5598 45.5104Z",
    fill: "url(#paint21_linear_722_15494)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0229 46.2226L83.0471 46.7231L83.6246 46.2959L82.6004 45.7953L82.0229 46.2226Z",
    fill: "url(#paint22_linear_722_15494)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1708 43.362L77.1949 43.8625L77.784 43.4236L76.7637 42.9231L76.1708 43.362Z",
    fill: "url(#paint23_linear_722_15494)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6338 44.0782L78.6579 44.5787L79.2469 44.1437L78.2229 43.6393L77.6338 44.0782Z",
    fill: "url(#paint24_linear_722_15494)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7725 47.0388L76.756 46.5344L76.1246 47.0041L77.1411 47.5124L77.7725 47.0388Z",
    fill: "url(#paint25_linear_722_15494)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2277 47.7626L78.2113 47.2583L77.576 47.728L78.5886 48.2362L79.2277 47.7626Z",
    fill: "url(#paint26_linear_722_15494)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6791 48.4865L79.6628 47.9782L79.0237 48.4556L80.04 48.96L80.6791 48.4865Z",
    fill: "url(#paint27_linear_722_15494)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4842 39.8355L69.6988 39.4466L69.0713 39.897L69.8759 40.2897L70.4842 39.8355Z",
    fill: "url(#paint28_linear_722_15494)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3207 46.3151L75.3044 45.8107L74.673 46.2766L75.6893 46.7848L76.3207 46.3151Z",
    fill: "url(#paint29_linear_722_15494)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5113 43.4236L69.4948 42.9155L68.875 43.3774L69.8914 43.8857L70.5113 43.4236Z",
    fill: "url(#paint30_linear_722_15494)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1306 49.2103L81.1142 48.702L80.4751 49.1795L81.4877 49.6877L82.1306 49.2103Z",
    fill: "url(#paint31_linear_722_15494)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.418 44.8713L72.4016 44.3631L71.774 44.829L72.7905 45.3372L73.418 44.8713Z",
    fill: "url(#paint32_linear_722_15494)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8695 45.5912L73.8532 45.0869L73.2256 45.5527L74.242 46.0609L74.8695 45.5912Z",
    fill: "url(#paint33_linear_722_15494)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8374 42.6613L70.8538 43.1696L71.4698 42.7114L70.4495 42.2071L69.8374 42.6613Z",
    fill: "url(#paint34_linear_722_15494)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1506 44.1205L76.167 44.6287L76.8523 44.1205L75.8282 43.62L75.1506 44.1205Z",
    fill: "url(#paint35_linear_722_15494)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6953 43.3967L74.7155 43.9048L75.3893 43.4043L74.3614 42.9038L73.6953 43.3967Z",
    fill: "url(#paint36_linear_722_15494)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9214 43.4353L71.905 42.9309L71.2889 43.3852L72.3054 43.8934L72.9214 43.4353Z",
    fill: "url(#paint37_linear_722_15494)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6021 44.8444L77.6184 45.3525L78.3153 44.8327L77.2912 44.3322L76.6021 44.8444Z",
    fill: "url(#paint38_linear_722_15494)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2437 42.6768L73.26 43.1811L73.9261 42.6883L72.8982 42.1878L72.2437 42.6768Z",
    fill: "url(#paint39_linear_722_15494)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0535 45.5681L79.0699 46.0764L79.7783 45.5489L78.7542 45.0484L78.0535 45.5681Z",
    fill: "url(#paint40_linear_722_15494)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2901 40.2975L72.8406 39.8893L71.7973 39.4004L71.266 39.797L72.2901 40.2975Z",
    fill: "url(#paint41_linear_722_15494)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3729 44.159L73.3565 43.6508L72.7405 44.109L73.7569 44.6171L74.3729 44.159Z",
    fill: "url(#paint42_linear_722_15494)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5049 46.2919L80.5212 46.8002L81.2412 46.2651L80.2171 45.7646L79.5049 46.2919Z",
    fill: "url(#paint43_linear_722_15494)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7042 46.9811L81.6802 46.4806L80.9602 47.0157L81.9766 47.524L82.7042 46.9811Z",
    fill: "url(#paint44_linear_722_15494)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6339 47.778L80.6174 47.2699L80.0015 47.728L81.0217 48.2323L81.6339 47.778Z",
    fill: "url(#paint45_linear_722_15494)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1673 47.6933L83.1431 47.1928L82.4116 47.7396L83.4281 48.2439L84.1673 47.6933Z",
    fill: "url(#paint46_linear_722_15494)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6342 48.4095L84.6062 47.909L83.8632 48.4634L84.8795 48.9678L85.6342 48.4095Z",
    fill: "url(#paint47_linear_722_15494)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8241 44.8828L74.8077 44.3747L74.1956 44.8328L75.2119 45.341L75.8241 44.8828Z",
    fill: "url(#paint48_linear_722_15494)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0855 48.4981L82.069 47.9937L81.4569 48.448L82.4733 48.9563L83.0855 48.4981Z",
    fill: "url(#paint49_linear_722_15494)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5428 47.7318L85.5225 47.2275L84.9489 47.6548L85.9768 48.1554L86.5428 47.7318Z",
    fill: "url(#paint50_linear_722_15494)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2758 45.6067L76.2594 45.0984L75.6472 45.5566L76.6637 46.0609L77.2758 45.6067Z",
    fill: "url(#paint51_linear_722_15494)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7311 46.3305L77.7108 45.8223L77.0986 46.2804L78.1151 46.7848L78.7311 46.3305Z",
    fill: "url(#paint52_linear_722_15494)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4858 46.9387L84.5138 47.4393L85.0836 47.0158L84.0634 46.5114L83.4858 46.9387Z",
    fill: "url(#paint53_linear_722_15494)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1825 47.0543L79.1661 46.5461L78.55 47.0043L79.5665 47.5086L80.1825 47.0543Z",
    fill: "url(#paint54_linear_722_15494)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9665 44.1475L70.9463 43.6393L70.3264 44.1012L71.339 44.6095L71.9665 44.1475Z",
    fill: "url(#paint55_linear_722_15494)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2333 47.9821L76.2439 48.7175L77.2564 49.2296L78.2498 48.4904L77.2333 47.9821Z",
    fill: "url(#paint56_linear_722_15494)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0846 42.9038L66.1376 43.6084L67.1501 44.1205L68.1011 43.412L67.0846 42.9038Z",
    fill: "url(#paint57_linear_722_15494)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1325 49.4335L79.1315 50.1767L80.144 50.6887L81.1488 49.9418L80.1325 49.4335Z",
    fill: "url(#paint58_linear_722_15494)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6847 48.7059L77.6875 49.449L78.7 49.9571L79.6972 49.2141L78.6847 48.7059Z",
    fill: "url(#paint59_linear_722_15494)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9778 49.2025L64.1085 52.0786L70.0145 55.5358L74.0339 52.2325L67.9778 49.2025Z",
    fill: "url(#paint60_linear_722_15494)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5839 50.1574L80.5752 50.9082L81.5839 51.4202L82.5964 50.6657L81.5839 50.1574Z",
    fill: "url(#paint61_linear_722_15494)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9837 44.3553L69.025 45.0677L70.0376 45.5797L71.0002 44.8636L69.9837 44.3553Z",
    fill: "url(#paint62_linear_722_15494)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5359 43.6315L67.5812 44.3399L68.5937 44.8482L69.5485 44.1397L68.5359 43.6315Z",
    fill: "url(#paint63_linear_722_15494)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7982 47.7666L71.4351 45.0792L70.4688 45.7991L72.2513 46.7L72.9251 47.0389L74.03 47.5971L74.3688 47.7704L75.8126 48.498L76.7982 47.7666Z",
    fill: "url(#paint64_linear_722_15494)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3428 39.2001C70.9039 39.0462 70.4573 39.05 70.0723 39.2117L70.8307 39.5852L71.3428 39.2001Z",
    fill: "url(#paint65_linear_722_15494)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8787 49.0832L88.8682 49.5683L89.4187 49.1447L88.4408 48.6635L87.8787 49.0832Z",
    fill: "url(#paint66_linear_722_15494)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6497 47.7666L88.7834 48.4095L89.7536 48.8869L89.8037 48.8484C90.1349 48.602 90.0347 48.0168 89.6497 47.7666Z",
    fill: "url(#paint67_linear_722_15494)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7757 42.2493L65.4754 42.4649C65.1674 42.6267 65.2367 43.1464 65.5909 43.3312L65.7064 43.389L66.6496 42.6883L65.7757 42.2493Z",
    fill: "url(#paint68_linear_722_15494)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4628 52.3673L83.8747 52.5752C84.2751 52.7793 84.7063 52.7639 85.0181 52.529L85.5302 52.1325L84.483 51.6089L83.4628 52.3673Z",
    fill: "url(#paint69_linear_722_15494)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0374 50.6578L84.0171 50.1497L83.3741 50.6309L84.3905 51.1391L85.0374 50.6578Z",
    fill: "url(#paint70_linear_722_15494)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7662 49.911L87.7711 50.4115L88.5334 49.8262L87.5362 49.3372L86.7662 49.911Z",
    fill: "url(#paint71_linear_722_15494)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8218 51.3548L85.8651 51.8784L86.5004 51.3855L85.4724 50.8735L84.8218 51.3548Z",
    fill: "url(#paint72_linear_722_15494)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0315 50.885L82.0189 51.6358L83.0276 52.1479L84.0479 51.3895L83.0315 50.885Z",
    fill: "url(#paint73_linear_722_15494)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5632 41.2638L67.7316 40.8518L67.104 41.3022L67.951 41.7219L68.5632 41.2638Z",
    fill: "url(#paint74_linear_722_15494)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4263 46.7578L86.2348 46.1572L85.1915 45.6721L84.406 46.2573L85.4263 46.7578Z",
    fill: "url(#paint75_linear_722_15494)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8854 47.4778L87.7247 46.854L86.6814 46.3651L85.8651 46.9734L86.8854 47.4778Z",
    fill: "url(#paint76_linear_722_15494)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9673 46.0417L84.7489 45.4604L83.7054 44.9753L82.9431 45.5374L83.9673 46.0417Z",
    fill: "url(#paint77_linear_722_15494)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3484 48.1938L89.2108 47.5509L88.1713 47.0619L87.3243 47.6933L88.3484 48.1938Z",
    fill: "url(#paint78_linear_722_15494)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M82.508 45.3217L83.2587 44.7634L82.2154 44.2784L81.4839 44.8212L82.508 45.3217Z",
    fill: "url(#paint79_linear_722_15494)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0058 48.4479L86.9817 47.9474L86.4158 48.3671L87.4398 48.8714L88.0058 48.4479Z",
    fill: "url(#paint80_linear_722_15494)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5205 48.7175L82.9083 49.1718L83.9248 49.68L84.5369 49.2218L83.5205 48.7175Z",
    fill: "url(#paint81_linear_722_15494)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0487 44.6056L81.7687 44.0666L80.7292 43.5815L80.0245 44.1012L81.0487 44.6056Z",
    fill: "url(#paint82_linear_722_15494)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9923 49.9456L84.9758 49.4413L84.3599 49.8956L86.8354 51.1315L87.4399 50.6656L85.9923 49.9456Z",
    fill: "url(#paint83_linear_722_15494)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0972 49.1255L86.0692 48.625L85.3147 49.1871L86.3311 49.6915L87.0972 49.1255Z",
    fill: "url(#paint84_linear_722_15494)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5333 40.5438L68.7209 40.1473L68.0818 40.6015L68.9057 41.0097L69.5333 40.5438Z",
    fill: "url(#paint85_linear_722_15494)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5822 49.9341L82.5659 49.4258L81.9229 49.9033L82.9393 50.4115L83.5822 49.9341Z",
    fill: "url(#paint86_linear_722_15494)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4272 42.6498L68.4399 43.158L69.0597 42.6998L68.0433 42.1917L67.4272 42.6498Z",
    fill: "url(#paint87_linear_722_15494)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6082 41.9761L66.7535 41.5526L66.126 41.9991L66.9922 42.4343L67.6082 41.9761Z",
    fill: "url(#paint88_linear_722_15494)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3148 40.5014L71.3389 41.0019L71.9472 40.5554L70.9231 40.051L70.3148 40.5014Z",
    fill: "url(#paint89_linear_722_15494)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1265 43.1696L78.7926 42.6768L77.7531 42.1878L77.1063 42.6691L78.1265 43.1696Z",
    fill: "url(#paint90_linear_722_15494)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5857 43.8895L80.2825 43.3697L79.2392 42.8847L78.5654 43.3852L79.5857 43.8895Z",
    fill: "url(#paint91_linear_722_15494)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6675 42.4535L77.3066 41.9799L76.2633 41.4909L75.6472 41.9491L76.6675 42.4535Z",
    fill: "url(#paint92_linear_722_15494)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7491 41.0174L74.3304 40.5862L73.2871 40.0972L72.725 40.5131L73.7491 41.0174Z",
    fill: "url(#paint93_linear_722_15494)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2082 41.7334L75.8165 41.2829L74.7732 40.7939L74.1841 41.2329L75.2082 41.7334Z",
    fill: "url(#paint94_linear_722_15494)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M91.5206 53.2258C95.2513 51.1662 98.3197 42.3803 98.3775 33.6099C98.4353 24.8356 95.4592 19.3956 91.7324 21.4591C88.0017 23.5189 84.9331 32.3047 84.8755 41.0752C84.8138 49.8456 87.7899 55.2856 91.5206 53.2258Z",
    fill: "#4A0101"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.077,
    d: "M91.5206 52.8062C95.1512 50.8004 98.1426 42.2494 98.1965 33.7099C98.2505 25.1706 95.3552 19.8729 91.7246 21.8788C88.094 23.8846 85.1025 32.4356 85.0486 40.9751C84.9947 49.5144 87.89 54.8121 91.5206 52.8062Z",
    fill: "#480202"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.115,
    d: "M91.5245 52.3866C95.055 50.4346 97.9656 42.1147 98.0195 33.8062C98.0734 25.4979 95.2552 20.3465 91.7247 22.2985C88.1942 24.2504 85.2836 32.5704 85.2296 40.8788C85.1757 49.1833 87.994 54.3386 91.5245 52.3866Z",
    fill: "#460303"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.154,
    d: "M91.5282 51.9669C94.9625 50.0688 97.7884 41.9838 97.8423 33.9063C97.8962 25.829 95.155 20.82 91.7246 22.7181C88.2942 24.6162 85.4644 32.7013 85.4106 40.7787C85.3566 48.8561 88.094 53.8649 91.5282 51.9669Z",
    fill: "#440404"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M91.5282 51.5473C94.8623 49.703 97.6074 41.849 97.6613 34.0064C97.7153 26.1639 95.051 21.2974 91.7169 23.1416C88.3827 24.9858 85.6376 32.8399 85.5837 40.6825C85.5337 48.525 88.1941 53.3876 91.5282 51.5473Z",
    fill: "#420505"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.231,
    d: "M91.5321 51.1238C94.77 49.3336 97.4342 41.7143 97.4843 34.0989C97.5343 26.4834 94.951 21.7634 91.717 23.5536C88.479 25.3439 85.8148 32.9631 85.7648 40.5785C85.7147 48.1939 88.2981 52.914 91.5321 51.1238Z",
    fill: "#400606"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.269,
    d: "M91.536 50.7041C94.6738 48.9716 97.2572 41.5795 97.3072 34.199C97.3573 26.8185 94.851 22.2407 91.7131 23.9732C88.5753 25.7058 85.992 33.0978 85.9419 40.4784C85.8919 47.8589 88.3982 52.4405 91.536 50.7041Z",
    fill: "#3E0606"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.308,
    d: "M91.5398 50.2844C94.5775 48.6057 97.0801 41.4486 97.1301 34.299C97.1763 27.1495 94.7508 22.7181 91.7131 24.3966C88.6754 26.0753 86.1728 33.2326 86.1228 40.382C86.0727 47.5316 88.4983 51.9668 91.5398 50.2844Z",
    fill: "#3C0707"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.346,
    d: "M91.54 49.8649C94.4815 48.2401 96.9031 41.3139 96.9494 34.3992C96.9955 27.4844 94.6509 23.1917 91.7094 24.8164C88.768 26.4411 86.3463 33.3673 86.3001 40.2821C86.2539 47.2006 88.6024 51.4895 91.54 49.8649Z",
    fill: "#3A0808"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.385,
    d: "M91.5439 49.4451C94.3853 47.8743 96.7261 41.1829 96.7723 34.4954C96.8185 27.8118 94.5509 23.6652 91.7056 25.236C88.8643 26.8069 86.5235 33.4983 86.4773 40.1858C86.4311 46.8733 88.7026 51.016 91.5439 49.4451Z",
    fill: "#380909"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.423,
    d: "M91.5476 49.0255C94.2927 47.5085 96.5489 41.0482 96.5912 34.5955C96.6335 28.1428 94.4467 24.1387 91.7016 25.6557C88.9566 27.1726 86.7004 33.6329 86.6581 40.0856C86.6157 46.5383 88.8025 50.5424 91.5476 49.0255Z",
    fill: "#360A0A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.462,
    d: "M91.5513 48.6058C94.1963 47.1428 96.3754 40.9173 96.4139 34.6956C96.4525 28.4739 94.3464 24.6161 91.7015 26.0792C89.0565 27.5422 86.8774 33.7677 86.8389 39.9894C86.7926 46.2073 88.9063 50.0689 91.5513 48.6058Z",
    fill: "#340B0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.5516 48.1862C94.0965 46.777 96.1948 40.7825 96.2332 34.7918C96.2717 28.8012 94.2428 25.0897 91.6941 26.4949C89.1491 27.9041 87.0509 33.8986 87.0124 39.8893C86.9739 45.8799 89.0067 49.5914 91.5516 48.1862Z",
    fill: "#330C0C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.538,
    d: "M91.5554 47.7666C94.004 46.4152 96.0176 40.6517 96.0561 34.892C96.0946 29.1361 94.1426 25.5633 91.694 26.9186C89.2453 28.2699 87.2318 34.0334 87.1933 39.7931C87.1548 45.5527 89.1067 49.1179 91.5554 47.7666Z",
    fill: "#310D0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.577,
    d: "M91.5593 47.3468C93.9078 46.0493 95.8405 40.5168 95.879 34.992C95.9175 29.4672 94.0425 26.0407 91.694 27.3382C89.3454 28.6357 87.4127 34.1682 87.3742 39.693C87.3358 45.2177 89.2107 48.6443 91.5593 47.3468Z",
    fill: "#2F0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M91.5591 46.9272C93.8076 45.6837 95.6633 40.3822 95.698 35.0922C95.7326 29.7984 93.9385 26.5143 91.6862 27.7579C89.4378 29.0014 87.582 34.3029 87.5474 39.5929C87.5166 44.8867 89.3107 48.1708 91.5591 46.9272Z",
    fill: "#2D0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.654,
    d: "M91.5628 46.5036C93.715 45.314 95.486 40.2473 95.5207 35.1845C95.5553 30.1217 93.8382 26.9839 91.686 28.1736C89.5339 29.3632 87.7628 34.43 87.7282 39.4928C87.6935 44.5556 89.4107 47.6933 91.5628 46.5036Z",
    fill: "#2B1010"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.692,
    d: "M91.5668 46.0841C93.6188 44.9483 95.309 40.1126 95.3436 35.2846C95.3745 30.4567 93.7382 27.4613 91.6861 28.5932C89.6341 29.7291 87.9439 34.5647 87.9092 39.3927C87.8746 44.2206 89.5147 47.2198 91.5668 46.0841Z",
    fill: "#291111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.731,
    d: "M91.5707 45.6644C93.5265 44.5825 95.1358 39.9818 95.1667 35.3848C95.1975 30.7878 93.6382 27.9349 91.6823 29.0168C89.7265 30.0987 88.1172 34.6995 88.0864 39.2964C88.0556 43.8934 89.6149 46.7463 91.5707 45.6644Z",
    fill: "#271212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.769,
    d: "M91.5705 45.2448C93.4262 44.2206 94.9547 39.847 94.9855 35.4811C95.0163 31.1151 93.534 28.4085 91.6783 29.4326C89.8226 30.4567 88.2941 34.8304 88.2633 39.1963C88.2363 43.5622 89.7148 46.2727 91.5705 45.2448Z",
    fill: "#251212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M91.5744 44.8251C93.33 43.8549 94.7777 39.7161 94.8046 35.5812C94.8315 31.4461 93.4301 28.882 91.6745 29.8561C89.9189 30.8263 88.4712 34.9651 88.4443 39.1C88.4135 43.235 89.8188 45.7953 91.5744 44.8251Z",
    fill: "#231313"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M91.5785 44.4055C93.2379 43.4891 94.6046 39.5814 94.6278 35.6813C94.6546 31.7812 93.3303 29.3595 91.6709 30.2757C90.0115 31.1921 88.6448 35.0999 88.6216 38.9999C88.5986 42.9 89.9191 45.3217 91.5785 44.4055Z",
    fill: "#211414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.885,
    d: "M91.582 43.9858C93.1413 43.1233 94.4271 39.4503 94.4502 35.7813C94.4734 32.1122 93.2297 29.8368 91.6706 30.6992C90.1113 31.5617 88.8253 35.2346 88.8022 38.9037C88.7753 42.5727 90.0188 44.8481 91.582 43.9858Z",
    fill: "#1F1515"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.923,
    d: "M91.5824 43.5662C93.0454 42.7577 94.2466 39.3157 94.2696 35.8776C94.2928 32.4396 93.1262 30.3066 91.6632 31.1151C90.2002 31.9236 88.9989 35.3656 88.9758 38.8037C88.9566 42.2417 90.1232 44.3747 91.5824 43.5662Z",
    fill: "#1D1616"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.962,
    d: "M91.586 43.1465C92.9489 42.3919 94.0692 39.1848 94.0924 35.9777C94.1155 32.7706 93.0259 30.784 91.663 31.5386C90.3001 32.2932 89.1797 35.5003 89.1566 38.7074C89.1373 41.9106 90.2231 43.8972 91.586 43.1465Z",
    fill: "#1B1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5899 42.7268C92.8527 42.0261 93.896 39.0499 93.9153 36.0777C93.9345 33.1055 92.9258 31.2614 91.663 31.9581C90.4002 32.655 89.3568 35.635 89.3375 38.6072C89.3145 41.5794 90.3232 43.4236 91.5899 42.7268Z",
    fill: "#191818"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9152 10.8599L62.5877 32.8014C62.453 33.4828 62.8033 34.1643 63.4309 34.4569L86.4388 45.0637C87.2704 45.4488 88.2444 44.9636 88.4369 44.0666L93.6498 20.0654C93.827 19.2415 93.365 18.4137 92.5719 18.1366L68.8133 9.78196C67.9817 9.4855 67.0884 9.99752 66.9152 10.8599Z",
    fill: "url(#paint95_linear_722_15494)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2182 11.041L61.8869 32.9785C61.7522 33.66 62.1025 34.3415 62.7301 34.634L85.738 45.2409C86.5696 45.6259 87.5436 45.1408 87.7361 44.2437L92.949 20.2425C93.1262 19.4186 92.6642 18.5909 91.8711 18.3137L68.1124 9.95904C67.2847 9.66267 66.3876 10.1747 66.2182 11.041Z",
    fill: "url(#paint96_linear_722_15494)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3386 44.3977C86.2731 44.3977 86.2077 44.3823 86.1461 44.3554L63.1382 33.7485C62.9149 33.6445 62.7917 33.4058 62.8379 33.1633L67.1692 11.2257C67.2193 10.9755 67.4426 10.8407 67.635 10.8407C67.689 10.8407 67.7429 10.8484 67.7929 10.8676L91.5516 19.2222C91.8826 19.3378 92.079 19.6881 92.002 20.0308L86.789 44.0319C86.739 44.2745 86.5273 44.3977 86.3386 44.3977Z",
    fill: "url(#paint97_linear_722_15494)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0306 26.4912L74.4921 21.9558C74.2688 21.8673 74.1225 21.6016 74.1687 21.3629C74.2111 21.1241 74.4305 21.001 74.65 21.0857L86.1885 25.621C86.4119 25.7096 86.5581 25.9752 86.512 26.2139C86.4696 26.4526 86.2501 26.5758 86.0306 26.4912Z",
    fill: "#D6D0D0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M85.022 21.0703L73.4141 16.7852C73.1908 16.7043 73.0446 16.4425 73.0869 16.2038C73.1292 15.9651 73.3487 15.8381 73.5719 15.9227L85.1799 20.2079C85.4032 20.2887 85.5495 20.5505 85.5071 20.7892C85.4609 21.024 85.2453 21.1511 85.022 21.0703Z",
    fill: "#D6D0D0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8851 27.3843L74.13 23.9424C73.9067 23.8538 73.7604 23.5882 73.8066 23.3495C73.849 23.1108 74.0684 22.9876 74.2879 23.0722L83.0429 26.5142C83.2662 26.6027 83.4125 26.8684 83.3663 27.1072C83.3239 27.3458 83.1045 27.4729 82.8851 27.3843Z",
    fill: "#D6D0D0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9705 20.2299L69.1986 21.6832C69.0306 21.8105 69.0097 22.0436 69.1174 22.2543C69.2908 22.3248 70.7947 22.9285 70.9706 22.9671C70.9706 22.9671 72.1797 23.3767 72.2119 23.383C72.2441 23.3893 72.3399 23.3447 72.3399 23.3447C72.4786 23.2383 72.5163 23.0289 72.4295 22.8532L71.5563 20.4128C71.4364 20.1714 71.16 20.0856 70.9705 20.2299Z",
    fill: "url(#paint98_linear_722_15494)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0579 20.8759C71.1451 20.9063 71.1944 20.9975 71.1732 21.0881L70.954 22.0326C70.9345 22.1169 70.8449 22.1663 70.7645 22.1374L70.7248 22.1176C70.6526 22.0919 70.6116 22.0169 70.628 21.9415L70.8283 21.0061C70.8511 20.9025 70.9595 20.8413 71.0579 20.8759Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7308 22.1795C70.818 22.21 70.8674 22.301 70.8463 22.3917L70.8396 22.4102C70.8201 22.4946 70.7213 22.5649 70.6407 22.536L70.5927 22.5151C70.5205 22.4894 70.4841 22.3945 70.5005 22.3192L70.5013 22.3097C70.5241 22.2061 70.6324 22.1449 70.7308 22.1795Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M85.122 31.4732L73.5834 26.9379C73.3601 26.8493 73.2138 26.5836 73.26 26.3449C73.3023 26.1062 73.5218 25.983 73.7412 26.0678L85.2798 30.6031C85.5032 30.6916 85.6494 30.9572 85.6033 31.196C85.5608 31.4347 85.3453 31.5578 85.122 31.4732Z",
    fill: "#D6D0D0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9766 32.3663L73.2216 28.9244C72.9983 28.8358 72.852 28.5702 72.8982 28.3315C72.9405 28.0928 73.16 27.9696 73.3795 28.0543L82.1345 31.4962C82.3577 31.5848 82.5041 31.8505 82.4578 32.0892C82.4155 32.3278 82.1998 32.4511 81.9766 32.3663Z",
    fill: "#D6D0D0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2005 24.8499L68.4286 26.3034C68.2605 26.4307 68.2397 26.6637 68.3473 26.8745C68.5207 26.9449 70.0248 27.5486 70.2005 27.5873C70.2005 27.5873 71.4096 27.9968 71.4418 28.0031C71.474 28.0094 71.5698 27.9649 71.5698 27.9649C71.7085 27.8585 71.7462 27.6491 71.6595 27.4733L70.7862 25.033C70.6664 24.7916 70.39 24.7057 70.2005 24.8499Z",
    fill: "url(#paint99_linear_722_15494)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2877 25.4961C70.3749 25.5265 70.4242 25.6175 70.403 25.7082L70.1837 26.6527C70.1642 26.7371 70.0747 26.7864 69.9943 26.7576L69.9545 26.7377C69.8824 26.7121 69.8414 26.6371 69.8577 26.5617L70.0581 25.6262C70.0808 25.5227 70.1892 25.4614 70.2877 25.4961Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9604 26.7996C70.0475 26.8301 70.0969 26.9212 70.0757 27.0119L70.0692 27.0303C70.0496 27.1146 69.9507 27.1849 69.8703 27.1561L69.8222 27.1352C69.75 27.1096 69.7136 27.0146 69.7299 26.9393L69.7308 26.9298C69.7535 26.8262 69.8619 26.765 69.9604 26.7996Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2173 36.4512L72.6787 31.9159C72.4554 31.8273 72.3092 31.5617 72.3553 31.323C72.3976 31.0843 72.6171 30.9611 72.8366 31.0458L84.3752 35.5811C84.5985 35.6697 84.7448 35.9354 84.6986 36.1741C84.6562 36.4166 84.4368 36.5398 84.2173 36.4512Z",
    fill: "#D6D0D0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M81.072 37.3444L72.317 33.9025C72.0938 33.8139 71.9474 33.5482 71.9937 33.3095C72.036 33.0708 72.2554 32.9476 72.4749 33.0324L81.2299 36.4743C81.4532 36.5628 81.5995 36.8285 81.5533 37.0672C81.5109 37.3097 81.2915 37.4329 81.072 37.3444Z",
    fill: "#D6D0D0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4307 29.47L67.6588 30.9234C67.4907 31.0507 67.4699 31.2837 67.5776 31.4945C67.751 31.5649 69.255 32.1686 69.4308 32.2073C69.4308 32.2073 70.6399 32.6169 70.6721 32.6232C70.7043 32.6294 70.8001 32.5849 70.8001 32.5849C70.9388 32.4785 70.9765 32.2691 70.8897 32.0933L70.0165 29.653C69.8967 29.4116 69.6203 29.3257 69.4307 29.47Z",
    fill: "url(#paint100_linear_722_15494)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5177 30.1161C69.6049 30.1465 69.6542 30.2376 69.6331 30.3282L69.4139 31.2728C69.3943 31.3571 69.3049 31.4064 69.2243 31.3776L69.1846 31.3577C69.1124 31.3321 69.0714 31.2571 69.0878 31.1817L69.2881 30.2462C69.311 30.1426 69.4193 30.0814 69.5177 30.1161Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1904 31.4196C69.2777 31.4501 69.327 31.5411 69.3059 31.6319L69.2992 31.6503C69.2796 31.7347 69.1809 31.805 69.1003 31.7762L69.0523 31.7552C68.9801 31.7295 68.9437 31.6347 68.9601 31.5593L68.9609 31.5498C68.9837 31.4463 69.092 31.385 69.1904 31.4196Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M109.759 36.0139C109.769 36.0009 109.782 35.9879 109.791 35.9749C109.797 35.9651 109.804 35.9586 109.81 35.9488C109.819 35.9359 109.829 35.9197 109.838 35.9067C109.845 35.897 109.851 35.8872 109.854 35.8776C109.863 35.8613 109.869 35.8452 109.879 35.829C109.882 35.8192 109.888 35.8096 109.891 35.7999C109.901 35.7805 109.907 35.7579 109.913 35.7353C109.916 35.7288 109.919 35.7223 109.919 35.716C109.928 35.6868 109.934 35.6579 109.943 35.6256C109.946 35.6191 109.946 35.6095 109.946 35.6031C109.949 35.5806 109.955 35.5548 109.958 35.5322C109.961 35.5193 109.961 35.5065 109.961 35.4968C109.963 35.4744 109.963 35.4551 109.966 35.4325C109.966 35.4197 109.966 35.4037 109.969 35.3907L109.967 35.2784C109.967 35.2559 109.963 35.2303 109.963 35.2078C109.962 35.1917 109.959 35.1789 109.959 35.1628C109.955 35.1372 109.951 35.1083 109.948 35.0828C109.944 35.0699 109.944 35.0571 109.941 35.0443C109.934 35.0026 109.927 34.9642 109.916 34.9226L109.916 34.9162C109.906 34.881 109.899 34.8426 109.886 34.8043C109.885 34.801 109.882 34.7946 109.882 34.7915C109.882 34.785 109.879 34.7819 109.879 34.7754L109.838 34.6508C109.838 34.6476 109.835 34.6444 109.835 34.6413C109.818 34.5965 109.801 34.5518 109.781 34.5072L105.624 23.1298C105.607 23.0948 105.594 23.0596 105.577 23.0245C105.577 23.0213 105.574 23.0182 105.574 23.015C105.56 22.983 105.544 22.9544 105.527 22.9226C105.52 22.9098 105.514 22.9003 105.511 22.8906C105.5 22.8683 105.487 22.8492 105.477 22.8269C105.471 22.8142 105.464 22.8015 105.454 22.7887C105.444 22.7696 105.431 22.7505 105.421 22.7314C105.415 22.7187 105.405 22.706 105.398 22.6932C105.391 22.6805 105.382 22.6679 105.375 22.6583C105.372 22.6551 105.368 22.6519 105.368 22.6456C105.345 22.6074 105.319 22.5724 105.293 22.5375C105.293 22.5375 105.293 22.5343 105.289 22.5343C105.263 22.4994 105.24 22.4677 105.214 22.4359C105.207 22.4265 105.197 22.4169 105.191 22.4073C105.171 22.382 105.152 22.3598 105.129 22.3377C105.119 22.3282 105.112 22.3187 105.103 22.3092C105.073 22.2776 105.047 22.249 105.017 22.2205L104.952 22.1573L104.933 22.1384C104.916 22.1226 104.9 22.1099 104.884 22.0941C104.877 22.0879 104.871 22.0815 104.864 22.0784C104.841 22.0595 104.818 22.0406 104.796 22.0248C104.773 22.0092 104.75 21.9903 104.727 21.9745C104.721 21.9682 104.714 21.9651 104.708 21.962C104.692 21.9494 104.675 21.94 104.656 21.9274C104.649 21.9244 104.643 21.918 104.636 21.9149C104.614 21.9024 104.591 21.8867 104.568 21.8743C104.539 21.8586 104.51 21.843 104.477 21.8274C104.474 21.8243 104.471 21.8243 104.468 21.8212C104.464 21.818 104.461 21.8181 104.458 21.8149C104.451 21.8118 104.442 21.8087 104.435 21.8056C104.425 21.7993 104.412 21.7963 104.403 21.7901C104.396 21.787 104.387 21.7839 104.38 21.7808C104.37 21.7777 104.357 21.7714 104.348 21.7684C104.341 21.7653 104.331 21.7623 104.325 21.7592C104.312 21.7561 104.302 21.7531 104.289 21.7501C104.283 21.7469 104.277 21.747 104.27 21.7439L104.231 21.7349C104.225 21.735 104.222 21.7318 104.215 21.7319C104.196 21.729 104.18 21.726 104.16 21.7231L104.154 21.7232C104.138 21.7203 104.122 21.7173 104.109 21.7175C104.102 21.7176 104.096 21.7177 104.089 21.7146C104.08 21.7148 104.07 21.7117 104.064 21.7118L103.996 21.7128C103.977 21.7131 103.957 21.7167 103.938 21.7169C103.932 21.717 103.925 21.7203 103.922 21.7204C103.909 21.7238 103.897 21.7241 103.881 21.7274C103.874 21.7276 103.868 21.7309 103.861 21.731C103.848 21.7344 103.836 21.7378 103.826 21.7412C103.823 21.7412 103.82 21.7445 103.813 21.7446C103.81 21.7447 103.807 21.7478 103.804 21.7479C103.791 21.7513 103.778 21.758 103.768 21.7613C103.762 21.7646 103.756 21.7647 103.752 21.768C103.736 21.7747 103.717 21.7846 103.701 21.7945L102.397 22.5178C102.413 22.508 102.429 22.4981 102.449 22.4914C102.455 22.4881 102.458 22.4881 102.465 22.4847C102.477 22.4781 102.487 22.4748 102.5 22.4713C102.506 22.468 102.513 22.4679 102.519 22.4646C102.532 22.4612 102.541 22.4578 102.554 22.4544C102.561 22.4544 102.567 22.451 102.573 22.4509C102.586 22.4475 102.599 22.4473 102.615 22.4439C102.622 22.4438 102.628 22.4404 102.631 22.4404C102.65 22.4368 102.67 22.4366 102.689 22.4363L102.75 22.4353C102.76 22.4352 102.773 22.435 102.782 22.4381C102.789 22.438 102.795 22.4379 102.802 22.441C102.818 22.444 102.831 22.4437 102.847 22.4467L102.853 22.4466C102.873 22.4495 102.933 22.4841 102.953 22.487C102.959 22.4869 102.962 22.4901 102.969 22.49L103.008 22.499C103.014 22.5021 103.021 22.502 103.03 22.5051C103.04 22.5082 103.053 22.5112 103.066 22.5142C103.072 22.5173 103.082 22.5204 103.088 22.5235C103.098 22.5266 103.111 22.5327 103.121 22.5358C103.127 22.5389 103.137 22.542 103.143 22.5451C103.153 22.5482 103.166 22.5544 103.176 22.5606C103.182 22.5638 103.192 22.5668 103.199 22.5699L103.218 22.5793C103.247 22.5949 103.276 22.6073 103.309 22.6261C103.332 22.6385 103.354 22.6511 103.377 22.6667C103.383 22.6698 103.39 22.6762 103.397 22.6793C103.413 22.6886 103.429 22.7013 103.448 22.7138C103.455 22.7169 103.461 22.7233 103.468 22.7264C103.514 22.7577 103.559 22.7924 103.602 22.8303C103.608 22.8366 103.615 22.843 103.621 22.846C103.637 22.8587 103.654 22.8744 103.67 22.8902L103.69 22.9093C103.712 22.9282 103.732 22.9504 103.755 22.9725C103.784 23.0009 103.811 23.0294 103.84 23.061C103.85 23.0706 103.856 23.0801 103.866 23.0896C103.886 23.1118 103.906 23.1372 103.928 23.1593C103.935 23.1688 103.945 23.1783 103.951 23.1878C103.978 23.2196 104.004 23.2512 104.027 23.2862L104.03 23.2894C104.056 23.3244 104.08 23.3593 104.106 23.3974C104.116 23.4133 104.126 23.4292 104.139 23.4451C104.145 23.4579 104.155 23.4705 104.162 23.4833C104.172 23.5024 104.185 23.5215 104.195 23.5406C104.202 23.5533 104.211 23.566 104.218 23.5788C104.231 23.6011 104.241 23.6202 104.251 23.6425C104.258 23.652 104.264 23.6647 104.268 23.6744C104.284 23.703 104.298 23.735 104.314 23.7668C104.314 23.77 104.318 23.7732 104.318 23.7764C104.334 23.8115 104.351 23.8465 104.364 23.8816L108.515 35.2559C108.535 35.3006 108.552 35.3452 108.569 35.3899C108.569 35.3932 108.572 35.3964 108.572 35.3996C108.589 35.441 108.402 35.3909 108.413 35.4325C108.413 35.439 108.416 35.4422 108.416 35.4485C108.43 35.4901 108.44 35.5317 108.45 35.5733L108.45 35.5797C108.461 35.6213 108.468 35.663 108.475 35.7014C108.478 35.7142 108.478 35.727 108.482 35.7398C108.485 35.7655 108.489 35.7943 108.493 35.82C108.493 35.836 108.496 35.8488 108.497 35.8648C108.5 35.8873 108.501 35.913 108.501 35.9355L108.503 36.0478C108.503 36.0607 108.503 36.0768 108.5 36.0897C108.501 36.1121 108.498 36.1346 108.495 36.154C108.495 36.1668 108.492 36.1798 108.492 36.1893C108.489 36.2151 108.486 36.2376 108.48 36.2602C108.48 36.2667 108.477 36.2763 108.477 36.2828C108.471 36.315 108.462 36.344 108.453 36.373C108.45 36.3795 108.447 36.386 108.447 36.3924C108.441 36.415 108.431 36.4344 108.425 36.457C108.422 36.4667 108.416 36.4764 108.413 36.4861C108.407 36.5023 108.397 36.5184 108.388 36.5346C108.382 36.5444 108.379 36.554 108.372 36.5638C108.363 36.5768 108.353 36.593 108.344 36.606C108.338 36.6157 108.331 36.6222 108.325 36.6319C108.316 36.645 108.303 36.658 108.294 36.671C108.287 36.6775 108.281 36.6873 108.275 36.6937C108.262 36.7069 108.237 36.6937 108.237 36.7297C108.237 36.7388 108.224 36.7395 108.218 36.7461C108.198 36.7624 108.176 36.7756 108.154 36.7888L108.633 36.6319L109.613 36.1254C109.636 36.1121 109.655 36.099 109.677 36.0827C109.683 36.0761 109.69 36.0728 109.696 36.0663C109.709 36.0564 109.721 36.0434 109.734 36.0304C109.744 36.027 109.75 36.0205 109.759 36.0139Z",
    fill: "#ED4944"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M102.426 22.526L94.408 29.1026C93.6475 29.6785 93.5534 30.7332 94.0406 31.6869C94.8253 32.0056 101.631 34.7373 102.426 34.9123C102.426 34.9123 107.897 36.7653 108.043 36.7938C108.189 36.8222 108.622 36.6206 108.622 36.6206C109.25 36.1392 109.42 35.1919 109.028 34.3965L105.076 23.3542C104.534 22.2619 103.284 21.8732 102.426 22.526Z",
    fill: "url(#paint101_linear_722_15494)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M102.821 25.4495C103.215 25.5873 103.439 25.9992 103.343 26.4098L102.351 30.6835C102.262 31.065 101.857 31.2884 101.493 31.1578L101.313 31.0679C100.987 30.9518 100.801 30.6124 100.875 30.2714L101.782 26.0385C101.885 25.5699 102.375 25.2928 102.821 25.4495Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M101.34 31.3481C101.734 31.4859 101.958 31.8979 101.862 32.3084L101.832 32.392C101.744 32.7736 101.296 33.0917 100.932 32.9612L100.715 32.8664C100.388 32.7504 100.223 32.321 100.297 31.9801L100.301 31.9371C100.404 31.4685 100.895 31.1914 101.34 31.3481Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_15494",
    x1: 81.0533,
    y1: 51.8146,
    x2: 92.6421,
    y2: 67.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_722_15494",
    x1: 89.4548,
    y1: 54.308,
    x2: 86.7615,
    y2: 56.4469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_722_15494",
    x1: 94.5191,
    y1: 55.0886,
    x2: 90.9427,
    y2: 57.9289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_722_15494",
    x1: 100.333,
    y1: 55.3435,
    x2: 95.3611,
    y2: 59.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_722_15494",
    x1: 102.062,
    y1: 58.4607,
    x2: 98.486,
    y2: 61.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_722_15494",
    x1: 29.001,
    y1: 42.8787,
    x2: 59.6843,
    y2: 40.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_722_15494",
    x1: 88.3214,
    y1: 27.2998,
    x2: 83.9895,
    y2: 18.5221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_722_15494",
    x1: 66.9135,
    y1: 51.013,
    x2: 87.9477,
    y2: 50.5793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_722_15494",
    x1: 66.9135,
    y1: 50.868,
    x2: 87.9477,
    y2: 50.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_722_15494",
    x1: 102.988,
    y1: 27.6257,
    x2: 69.9641,
    y2: 27.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_722_15494",
    x1: 102.179,
    y1: 27.4596,
    x2: 70.8731,
    y2: 27.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_722_15494",
    x1: 96.8962,
    y1: 49.3891,
    x2: 52.403,
    y2: 49.3891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_722_15494",
    x1: 74.7306,
    y1: 64.5423,
    x2: 74.6867,
    y2: 55.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_722_15494",
    x1: 63.0393,
    y1: 43.3634,
    x2: 92.1518,
    y2: 42.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_722_15494",
    x1: 74.7043,
    y1: 42.5372,
    x2: 76.3219,
    y2: 42.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_722_15494",
    x1: 73.2409,
    y1: 41.8204,
    x2: 74.8621,
    y2: 41.7913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_722_15494",
    x1: 71.7774,
    y1: 41.1037,
    x2: 73.4023,
    y2: 41.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_722_15494",
    x1: 70.7899,
    y1: 41.8229,
    x2: 72.4577,
    y2: 41.7929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_722_15494",
    x1: 68.3826,
    y1: 41.8235,
    x2: 70.0123,
    y2: 41.7942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_722_15494",
    x1: 69.3377,
    y1: 41.1046,
    x2: 70.9941,
    y2: 41.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_722_15494",
    x1: 79.095,
    y1: 44.6875,
    x2: 80.7014,
    y2: 44.6587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_722_15494",
    x1: 80.5583,
    y1: 45.4043,
    x2: 82.1611,
    y2: 45.3756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_722_15494",
    x1: 82.0219,
    y1: 46.1211,
    x2: 83.6211,
    y2: 46.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_722_15494",
    x1: 76.1678,
    y1: 43.254,
    x2: 77.7817,
    y2: 43.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_722_15494",
    x1: 77.6313,
    y1: 43.9708,
    x2: 79.2415,
    y2: 43.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_722_15494",
    x1: 76.1226,
    y1: 46.8804,
    x2: 77.7709,
    y2: 46.8508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_722_15494",
    x1: 77.5722,
    y1: 47.6046,
    x2: 79.2231,
    y2: 47.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_722_15494",
    x1: 79.0219,
    y1: 48.3287,
    x2: 80.6754,
    y2: 48.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_722_15494",
    x1: 69.0694,
    y1: 39.7452,
    x2: 70.4837,
    y2: 39.7198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_722_15494",
    x1: 74.6725,
    y1: 46.1564,
    x2: 76.3183,
    y2: 46.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_722_15494",
    x1: 68.8738,
    y1: 43.2598,
    x2: 70.5094,
    y2: 43.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_722_15494",
    x1: 80.4717,
    y1: 49.0529,
    x2: 82.1277,
    y2: 49.0232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_722_15494",
    x1: 71.7732,
    y1: 44.7081,
    x2: 73.414,
    y2: 44.6786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_722_15494",
    x1: 73.2231,
    y1: 45.4321,
    x2: 74.8662,
    y2: 45.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_722_15494",
    x1: 69.8348,
    y1: 42.5469,
    x2: 71.4646,
    y2: 42.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_722_15494",
    x1: 75.1467,
    y1: 43.9777,
    x2: 76.8485,
    y2: 43.9472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_722_15494",
    x1: 73.6945,
    y1: 43.2594,
    x2: 75.3849,
    y2: 43.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_722_15494",
    x1: 71.2873,
    y1: 43.2704,
    x2: 72.917,
    y2: 43.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_722_15494",
    x1: 76.5989,
    y1: 44.696,
    x2: 78.312,
    y2: 44.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_722_15494",
    x1: 72.2422,
    y1: 42.5412,
    x2: 73.9213,
    y2: 42.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_722_15494",
    x1: 78.0511,
    y1: 45.4143,
    x2: 79.7756,
    y2: 45.3833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_722_15494",
    x1: 71.2647,
    y1: 39.7163,
    x2: 72.8368,
    y2: 39.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_722_15494",
    x1: 72.7395,
    y1: 43.9938,
    x2: 74.3693,
    y2: 43.9645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_722_15494",
    x1: 79.5032,
    y1: 46.1327,
    x2: 81.2389,
    y2: 46.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_722_15494",
    x1: 80.9554,
    y1: 46.8509,
    x2: 82.7026,
    y2: 46.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_722_15494",
    x1: 80.0008,
    y1: 47.6108,
    x2: 81.6306,
    y2: 47.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_722_15494",
    x1: 82.4076,
    y1: 47.5691,
    x2: 84.1661,
    y2: 47.5376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_722_15494",
    x1: 83.8599,
    y1: 48.2876,
    x2: 85.6296,
    y2: 48.2558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_722_15494",
    x1: 74.1916,
    y1: 44.7172,
    x2: 75.8213,
    y2: 44.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_722_15494",
    x1: 81.4533,
    y1: 48.3344,
    x2: 83.083,
    y2: 48.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_722_15494",
    x1: 84.9489,
    y1: 47.5547,
    x2: 86.5406,
    y2: 47.5261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_722_15494",
    x1: 75.6441,
    y1: 45.4406,
    x2: 77.2739,
    y2: 45.4113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_722_15494",
    x1: 77.0964,
    y1: 46.1641,
    x2: 78.7261,
    y2: 46.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_722_15494",
    x1: 83.4853,
    y1: 46.8378,
    x2: 85.0808,
    y2: 46.8092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_722_15494",
    x1: 78.5486,
    y1: 46.8875,
    x2: 80.1783,
    y2: 46.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_722_15494",
    x1: 70.3235,
    y1: 43.9839,
    x2: 71.9616,
    y2: 43.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_722_15494",
    x1: 76.2389,
    y1: 48.4332,
    x2: 78.2471,
    y2: 48.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_722_15494",
    x1: 66.1343,
    y1: 43.3437,
    x2: 68.0986,
    y2: 43.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_722_15494",
    x1: 79.126,
    y1: 49.8872,
    x2: 81.1469,
    y2: 49.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_722_15494",
    x1: 77.6823,
    y1: 49.1602,
    x2: 79.6968,
    y2: 49.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_722_15494",
    x1: 64.0993,
    y1: 51.5297,
    x2: 74.0196,
    y2: 51.3516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_722_15494",
    x1: 80.5696,
    y1: 50.6143,
    x2: 82.5966,
    y2: 50.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_722_15494",
    x1: 69.0213,
    y1: 44.7978,
    x2: 70.9982,
    y2: 44.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_722_15494",
    x1: 67.5776,
    y1: 44.0707,
    x2: 69.5483,
    y2: 44.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_722_15494",
    x1: 70.4777,
    y1: 46.2505,
    x2: 76.7698,
    y2: 46.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_722_15494",
    x1: 70.0716,
    y1: 39.201,
    x2: 71.3421,
    y2: 39.1782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_722_15494",
    x1: 87.8757,
    y1: 48.9826,
    x2: 89.4146,
    y2: 48.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_722_15494",
    x1: 88.7798,
    y1: 48.1678,
    x2: 89.9987,
    y2: 48.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_722_15494",
    x1: 65.2766,
    y1: 42.7402,
    x2: 66.6512,
    y2: 42.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_722_15494",
    x1: 83.4555,
    y1: 51.9992,
    x2: 85.5285,
    y2: 51.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_722_15494",
    x1: 83.3711,
    y1: 50.5012,
    x2: 85.0322,
    y2: 50.4713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_722_15494",
    x1: 86.7644,
    y1: 49.7221,
    x2: 88.5292,
    y2: 49.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_722_15494",
    x1: 84.8209,
    y1: 51.2298,
    x2: 86.4986,
    y2: 51.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_722_15494",
    x1: 82.013,
    y1: 51.3414,
    x2: 84.0464,
    y2: 51.3049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_722_15494",
    x1: 67.1021,
    y1: 41.16,
    x2: 68.5612,
    y2: 41.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_722_15494",
    x1: 84.4011,
    y1: 46.0588,
    x2: 86.233,
    y2: 46.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_722_15494",
    x1: 85.8607,
    y1: 46.7636,
    x2: 87.7214,
    y2: 46.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_722_15494",
    x1: 82.9416,
    y1: 45.3541,
    x2: 84.7447,
    y2: 45.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_722_15494",
    x1: 87.3203,
    y1: 47.4682,
    x2: 89.2099,
    y2: 47.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_722_15494",
    x1: 81.4819,
    y1: 44.6493,
    x2: 83.256,
    y2: 44.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_722_15494",
    x1: 86.4123,
    y1: 48.2714,
    x2: 88.0004,
    y2: 48.2428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_722_15494",
    x1: 82.9055,
    y1: 49.0578,
    x2: 84.5353,
    y2: 49.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_722_15494",
    x1: 80.0222,
    y1: 43.9446,
    x2: 81.7675,
    y2: 43.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_722_15494",
    x1: 84.3622,
    y1: 50.0203,
    x2: 87.4256,
    y2: 49.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_722_15494",
    x1: 85.3121,
    y1: 49.0058,
    x2: 87.0932,
    y2: 48.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_722_15494",
    x1: 68.0801,
    y1: 40.4532,
    x2: 69.5319,
    y2: 40.4272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_722_15494",
    x1: 81.9216,
    y1: 49.7771,
    x2: 83.5802,
    y2: 49.7473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_722_15494",
    x1: 67.424,
    y1: 42.5356,
    x2: 69.0569,
    y2: 42.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_722_15494",
    x1: 66.1228,
    y1: 41.8637,
    x2: 67.6056,
    y2: 41.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_722_15494",
    x1: 70.3136,
    y1: 40.3869,
    x2: 71.9422,
    y2: 40.3577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_722_15494",
    x1: 77.103,
    y1: 42.5352,
    x2: 78.7905,
    y2: 42.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_722_15494",
    x1: 78.5625,
    y1: 43.2398,
    x2: 80.2789,
    y2: 43.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_722_15494",
    x1: 75.6435,
    y1: 41.8305,
    x2: 77.3021,
    y2: 41.8007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_722_15494",
    x1: 72.724,
    y1: 40.421,
    x2: 74.3251,
    y2: 40.3923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_722_15494",
    x1: 74.1837,
    y1: 41.1256,
    x2: 75.8135,
    y2: 41.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_722_15494",
    x1: 81.7492,
    y1: 32.6809,
    x2: 72.5703,
    y2: 16.7208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_722_15494",
    x1: 61.8604,
    y1: 27.6212,
    x2: 92.9913,
    y2: 27.6212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_722_15494",
    x1: 62.8307,
    y1: 27.6211,
    x2: 92.0208,
    y2: 27.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_722_15494",
    x1: 72.2484,
    y1: 22.171,
    x2: 69.2806,
    y2: 22.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_722_15494",
    x1: 71.4784,
    y1: 26.7912,
    x2: 68.5105,
    y2: 27.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_722_15494",
    x1: 70.7086,
    y1: 31.4112,
    x2: 67.7407,
    y2: 32.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_722_15494",
    x1: 108.208,
    y1: 31.3098,
    x2: 94.7789,
    y2: 35.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimChart);
export default __webpack_public_path__ + "static/media/ClaimChart.3498e1ebe30cac734c19a74e206a8cb5.svg";
export { ForwardRef as ReactComponent };